import React from 'react';
import { Container } from 'react-bootstrap';
import { Helmet } from 'react-helmet';

const CookiePolicy = () => {
    return (
        <div className="bg-light py-5">
            <Helmet>
                <title>Cookie Policy | SpireNest</title>
                <link rel="canonical" href="https://spirenest.co/cookie-policy" />
                <meta name="description" content="Learn about SpireNest's cookie policy and how we use cookies to enhance your browsing experience." />
            </Helmet>
            <Container>
                <div className="max-w-4xl mx-auto">
                    <h1 className="mb-4">Cookie Policy</h1>

                    <p className="mb-4">
                        This Cookie Policy explains how SuiteMatrix ("we", "our", or "us") uses cookies and similar technologies when you visit our website.
                    </p>

                    <h2 className="mb-3">What Are Cookies</h2>
                    <p className="mb-4">
                        Cookies are small text files that are placed on your device when you visit a website. They help us provide you with a better experience and understand how you use our website.
                    </p>

                    <h2 className="mb-3">Types of Cookies We Use</h2>
                    <p className="mb-2">We use the following types of cookies:</p>
                    <ul className="mb-4">
                        <li><strong>Essential Cookies:</strong> Required for the website to function properly</li>
                        <li><strong>Analytics Cookies:</strong> Help us understand how visitors interact with our website</li>
                        <li><strong>Functional Cookies:</strong> Remember your preferences and settings</li>
                        <li><strong>Marketing Cookies:</strong> Used to deliver relevant advertisements</li>
                    </ul>

                    <h2 className="mb-3">How We Use Cookies</h2>
                    <p className="mb-2">We use cookies to:</p>
                    <ul className="mb-4">
                        <li>Remember your preferences and settings</li>
                        <li>Analyze website traffic and usage patterns</li>
                        <li>Improve our website functionality</li>
                        <li>Provide personalized content and advertisements</li>
                        <li>Ensure website security</li>
                    </ul>

                    <h2 className="mb-3">Third-Party Cookies</h2>
                    <p className="mb-4">
                        We may also use third-party cookies from services like Google Analytics, social media platforms, and advertising networks. These third parties have their own privacy policies.
                    </p>

                    <h2 className="mb-3">Managing Cookies</h2>
                    <p className="mb-4">
                        You can control and manage cookies through your browser settings. You can delete existing cookies and prevent new ones from being set. However, disabling certain cookies may affect website functionality.
                    </p>

                    <h2 className="mb-3">Your Choices</h2>
                    <p className="mb-4">
                        When you first visit our website, you will see a cookie banner that allows you to accept or decline non-essential cookies. You can change your preferences at any time.
                    </p>

                    <h2 className="mb-3">Updates to This Policy</h2>
                    <p className="mb-4">
                        We may update this Cookie Policy from time to time. Any changes will be posted on this page with an updated revision date.
                    </p>

                    <h2 className="mb-3">Contact Us</h2>
                    <p className="mb-0">
                        If you have any questions about our use of cookies, please contact us at <a href="mailto:support@suitematrix.co">support@suitematrix.co</a>.
                    </p>
                </div>
            </Container>
        </div>
    );
};

export default CookiePolicy; 